// Formatage monétaire XOF (entier, séparateur milliers).
export function formatXof(n) {
  if (n == null) return '—';
  const s = new Intl.NumberFormat('fr-FR').format(Math.abs(n));
  return `${n < 0 ? '-' : ''}${s} F`;
}

export const PAYMENT_METHODS = {
  ESPECES: 'Espèces',
  ORANGE_MONEY: 'Orange Money',
  MOOV_MONEY: 'Moov Money',
  WAVE: 'Wave',
  VIREMENT: 'Virement',
  CHEQUE: 'Chèque',
};

export const INVOICE_STATUS = {
  OUVERTE: ['gray', 'Ouverte'],
  PARTIELLE: ['gold', 'Partielle'],
  PAYEE: ['green', 'Payée'],
  ANNULEE: ['red', 'Annulée'],
};
